import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { ArtworkService } from '@api-services';
import { watchParentParam } from '@utils';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'wun-sales',
  standalone: true,
  imports: [CurrencyPipe, DatePipe, RouterLink],
  templateUrl: './sales.component.html',
  styleUrl: './sales.component.scss'
})
export class SalesComponent {

  private readonly artworkService = inject(ArtworkService);
  artist = watchParentParam("id", 2);
  
  sales = rxResource({
    params: this.artist,
    stream: params => {
      return this.artworkService.artworksFindAndPaginate({
        filters: JSON.stringify({artist: params.params}),
        includes: JSON.stringify(['orderRows.order', 'mainAttachment']),
      })
    }
  })

  statusLabel(status: string): string {
    const map: Record<string, string> = {
      CREATED: 'In attesa',
      PAYED: 'Pagato',
      SHIPPED: 'Spedito',
      DELIVERED: 'Consegnato',
    };
    return map[status] ?? status;
  }

  statusClass(status: string): string {
    const map: Record<string, string> = {
      CREATED: 'bg-yellow-100 text-yellow-800',
      PAYED: 'bg-blue-100 text-blue-800',
      SHIPPED: 'bg-purple-100 text-purple-800',
      DELIVERED: 'bg-green-100 text-green-800',
    };
    return map[status] ?? 'bg-gray-100 text-gray-800';
  }
}
